import {SearchType} from 'modules/sapiSearch/utils'
import {defaultTo} from 'ramda'
import {createSelector} from 'reselect'

import {SuggestionSectionDataType} from '@vio/core/src/autocomplete/types'

import {
  OpenState,
  SearchBoxAncestor,
  SearchBoxStateType,
  SearchTrigger
} from './types'

export type StateType = {
  searchBox: SearchBoxStateType
}

export const getSearchBoxValues = (state: StateType) =>
  state.searchBox.values || {}

export const getIsDatesVisible = ({searchBox}: StateType): boolean =>
  searchBox?.isDatesVisible || searchBox?.isDatesVisible === null

export const getOpenDatePickerType = createSelector(
  [(state: StateType) => state.searchBox.openDatePickerType],
  openDatePickerType => openDatePickerType
)

/**
 * Gets the current search destination
 */
export const getSearchBoxDestinationDisplayValue = (state: StateType) =>
  state.searchBox.searchBoxDestinationDisplayValue

const getSearchBoxOpenState = (state: StateType): OpenState =>
  defaultTo(OpenState.Closed, state.searchBox.openState)

export const getIsSearchBoxOpen = createSelector(
  [getSearchBoxOpenState],
  (openState): boolean =>
    [OpenState.OpenByDefault, OpenState.OpenByUser].includes(openState)
)

export const getSearchBoxAncestor = (
  state: StateType
): SearchBoxAncestor | null | undefined => state.searchBox.ancestor

export const getIsSearchBoxActive = (state: StateType): boolean =>
  state.searchBox.isSearchBoxActive

export const getSuggestions = (state: StateType): SuggestionSectionDataType[] =>
  state.searchBox.suggestions

export const getSuggestionSearchValue = (state: StateType): string =>
  state.searchBox.suggestionsSearchValue

export const getSearchBoxSearchTrigger = (
  state: StateType
): SearchTrigger | null | undefined => state.searchBox.searchTrigger

/**
 * If MRB is enabled, don't show the label
 */
export const getShowRoomsLabel = createSelector(
  [getSearchBoxValues],
  ({optimizeRooms}): boolean => Boolean(!optimizeRooms)
)

export const getSearchBoxSearchType = createSelector(
  [getSearchBoxValues],
  ({
    hotelId,
    placeId,
    userLocationSearch,
    address,
    boundingBox
  }): SearchType => {
    if (hotelId) {
      return SearchType.Hotel
    }
    if (placeId) {
      return SearchType.Place
    }
    if (userLocationSearch) {
      return SearchType.Location
    }
    if (address) {
      return SearchType.Address
    }
    if (boundingBox) {
      return SearchType.Area
    }
    return SearchType.Unknown
  }
)

export const getIsUserChangedDates = (state: StateType): boolean =>
  state.searchBox.isUserChangedDates
